import {
  changePassword,
  ChangePasswordPayload,
  setPasswordWithTemp,
  SetPasswordWithTempPayload,
} from "../webclients/account.client";

export const accountApi = {
  /**
   * Set password with temporary password (Public - No Auth Required)
   */
  setPasswordWithTemp: async (data: SetPasswordWithTempPayload): Promise<void> => {
    await setPasswordWithTemp(data);
  },

  /**
   * Change password (Auth Required)
   */
  changePassword: async (data: ChangePasswordPayload): Promise<void> => {
    await changePassword(data);
  },
};

export default accountApi;

